export const StreamType = {
    PLAYLIST: 1,
    BROADCASTING: 2,
  }
  